import axios from 'axios';
import {API_URL, CUST, INDEX_URL} from '../helpers/constants.js';
import toast from 'react-hot-toast';
import { useParams } from "react-router-dom";

const throwUser = (error) => {
    if(error?.response?.data?.errorCode === "10003" || error?.response?.data?.errorCode === "10002"){
        localStorage.clear()
        window.location.href = `${INDEX_URL}/login`
    }
}

export async function post(id, url, formData) {
	const headers = {
		'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': `${CUST}`,
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	};
    return axios({
        url: API_URL+url,
        method: "POST",
        config: headers,
        data: formData,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}

export async function postWithFiles(id, url, formData){
    const headers = {
		'Content-Type':'multipart/form-data',
		'cache-control':'no-cache',
        'flavor': `${CUST}`,
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	};

    return axios({
        url: API_URL+url,
        method: "POST",
        headers,
        data: formData,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}


export async function generatePDFpost(url, formData) {
    const headers = {
      'Content-Type': 'application/json',
      'cache-control':'no-cache',
      'flavor': `${CUST}`,
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    //   ...customHeaders,
    };
  
    return axios({
        url: API_URL+url,
        method: "POST",
        data: formData,
        crossDomain: true,
        headers: headers,
        responseType: 'blob'
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throwUser(error)
        return error.response;
      });
}



export async function get(url){
    const headers = {
		'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': `${CUST}`,
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	}; 
    return axios({
        url: API_URL+url,
        method: "GET",
        config: headers,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}

export async function getSubscription(url, spec = null){

    const headers = {
		'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': CUST,
        ...(spec ? { Authorization: spec } : {}),
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	}; 
    return axios({
        url: 'https://api.cloudappapi.com/'+url,
        method: "GET",
        config: headers,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}

export async function postSubscription(id, url, formData, spec = null) {
	const headers = {
		'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': CUST,
        ...(spec ? { Authorization: spec } : {}),
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	};
    return axios({
        url: 'https://api.cloudappapi.com/'+url,
        method: "POST",
        config: headers,
        data: formData,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}

export async function generatePDFget(url) {
    const headers = {
		'Content-Type':'application/pdf',
		'cache-control':'no-cache',
        'flavor': CUST,
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    };
  
    return axios({
        url: 'https://api.cloudappapi.com/'+url,
        method: "GET",
        crossDomain: true,
        config: headers,
        headers: headers,
        responseType: 'blob'
    })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        throwUser(error)
        return error.response;
      });
}

export async function postUnique(id, url, formData) {
	const headers = {
		'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': CUST,
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	};
    return axios({
        url: 'https://api.cloudappapi.com/'+url,
        method: "POST",
        config: headers,
        data: formData,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}

export async function getUnique(url){
    const headers = {
		'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': CUST,
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	}; 
    return axios({
        url: 'https://api.cloudappapi.com/'+url,
        method: "GET",
        config: headers,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}


export async function put(url, formData){
    const headers = {
		'cache-control':'no-cache',
		'Access-Control-Allow-Origin' : '*',
		'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
	}; 
    let datapic = new FormData();
    datapic.append('File', formData);
    datapic.append('publictoken', 'wcySegj73wuAA-swet-up-4W6&76+0D/f?f$Q+$f3$5?3D$2b$10$Dlwq5z2fAA2qwcySegj73wu4pf/Cf.33xHaBTrCi7afkascg5IJBgC');
    return axios({
        url: API_URL+url,
        method: "PUT",
        config: headers,
        data: datapic,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}


export async function putNew(url, formData){
    const headers = {
		// 'Content-Type':'application/json',
		'cache-control':'no-cache',
        'flavor': `${CUST}`
	}; 
    let datapic = new FormData();
    datapic.append('image', formData.image);
    datapic.append('type', formData.type);
    datapic.append('entity_id', formData.entity_id);
    //datapic.append('publictoken', 'wcySegj73wuAA-swet-up-4W6&76+0D/f?f$Q+$f3$5?3D$2b$10$Dlwq5z2fAA2qwcySegj73wu4pf/Cf.33xHaBTrCi7afkascg5IJBgC');
    return axios({
        url: API_URL+url,
        method: "POST",
        config: headers,
        data: datapic,
        headers: headers,
        crossDomain: true
    }).then(function (response) {
        return response
    }).catch(function (error) {
        throwUser(error)
        return error.response
    })
}